import { IWorkflowStep } from '~/client/graph'

import { getWorkflowStepLevel } from '../constants/formStatusesTags'
import Workflow from '../models/Workflow'

export function advanceToNextWorkflowStep(
  permit: Workflow,
  steps: IWorkflowStep[],
): void {
  const currentIndex = steps.findIndex(
    s => s.id === permit.currentWorkflowStepId,
  )
  if (currentIndex === -1) {
    return
  }

  permit.setWorkflowStepLevel(
    getWorkflowStepLevel(steps[currentIndex].id, steps),
  )

  const nextIndex = Math.min(currentIndex + 1, steps.length - 1)
  permit.setWorkflowStepId(steps[nextIndex].id)
}
